import React, { useEffect, useState, useRef } from "react";
import BlackHeader from "../Layout/BlackHeader/BlackHeader";
import styles from "./Disclaimer.module.scss";
import Footer from "../Layout/Footer/Footer";
import useLocoScroll from "../../hooks/useLocoScroll";
import useOnScreen from "../../hooks/useOnScreen";
import img from "../../Assets/lrc-investment-lifecycle.png";
import MetaDecorator from "../Util/MetaDecorator";
export default function Disclaimer() {
	useLocoScroll(true);
	const ref = useRef(null);

	const [reveal, setReveal] = useState(false);
	const onScreen = useOnScreen(ref);

	useEffect(() => {
		if (onScreen) setReveal(onScreen);
	}, [onScreen]);
	return (
		<>
		<MetaDecorator
						title={"LRC Group | Political Engagement Policy"}
						description={
							"We are very delighted that you have shown interest in our enterprise. Data protection is of a particularly high priority for the management of the LRC Group. The use of the Internet pages of the LRC Group is possible without any indication of personal data; however, if a data subject wants to use special enterprise services via our website, processing of personal data could become necessary."
						}
					/>
			<div className="sticky-header">
				<BlackHeader />
			</div>
			<div
				id="main-container"
				data-scroll-container>
				<section
					className={styles.DisclaimerAlignment}
					data-scroll-section>
					<div className="container">
						<div className={styles.boxCenterAlignment}>
							<div className={styles.boxWidth}>
								<div className={styles.pageTitle}>
									<h1>Political Engagement disclosure</h1>
								</div>
								<div className={styles.subTextAlignment}>
									<h2>1. Purpose and Scope</h2>
									<p>
										This disclosure sets out the LRC Group’s approach to
										political engagement across all jurisdictions in which it
										operates, with particular reference to the United Kingdom
										and the European Union. It outlines our guiding principles,
										commitments, and practices regarding interactions with
										political stakeholders, lobbying, and political
										contributions.
									</p>
									<h2>2. Guiding Principles</h2>
									<p>
										We are committed to conducting our business in a
										transparent, ethical, and non-partisan manner. Our political
										engagement is guided by the following principles:
									</p>
									<ul>
										<li>
											<b>Compliance:</b> We comply fully with all relevant laws
											and regulations governing political engagement, lobbying,
											and political donations in the jurisdictions where we
											operate, including the UK's Transparency of Lobbying,
											Non-party Campaigning and Trade Union Administration Act
											2014, and applicable EU transparency and ethics
											regulations.
										</li>
										<li>
											<b>Transparency:</b> We are committed to openness in our
											political engagement and, where applicable, register our
											lobbying activities with relevant authorities.
										</li>
										<li>
											<b>Integrity and Accountability:</b> All political
											engagement must align with our corporate values and be
											approved in accordance with our internal governance
											structures.
										</li>
									</ul>
									<h2>3. Political Contributions</h2>
									<p>
										The LRC Group does not make donations to political parties,
										candidates, or political organisations, whether in cash or
										in kind, in any jurisdiction. Any exception to this policy
										must be approved by the CEO and publicly disclosed, in line
										with applicable UK and EU requirements.
									</p>
									<h2>4. Lobbying and Advocacy</h2>
									<p>
										We may engage in lobbying activities where it is appropriate
										and in line with our legitimate business interests. Such
										activities include:
									</p>
									<ul>
										<li>Contributing to public consultations;</li>
										<li>Participating in industry associations;</li>
										<li>
											Engaging with policymakers on matters that affect our
											operations.
										</li>
									</ul>
									<p>
										All lobbying activities are conducted in accordance with:
									</p>
									<ul>
										<li>
											<b>UK:</b> The Office of the Registrar of Consultant
											Lobbyists and other applicable transparency requirements;
										</li>
										<li>
											<b>EU:</b> The EU Transparency Register and the Code of
											Conduct for interest representatives.
										</li>
									</ul>
									<p>
										We ensure that our representatives are registered, if
										required, and comply with all conduct and reporting
										obligations.
									</p>
									<h2>5. Industry Associations and Third Parties</h2>
									<p>
										We may be members of trade or industry associations that
										engage in political advocacy. We expect these organisations
										to operate transparently and ethically. We regularly review
										our memberships to ensure alignment with our values and
										disclose material memberships in our annual reporting.
									</p>
									<h2>6. Oversight and Review</h2>
									<p>
										The CEO has ultimate oversight of our political engagement
										activities. This disclosure and our internal Political
										Engagement Policy are reviewed annually to ensure compliance
										with evolving legal requirements and stakeholder
										expectations.
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<>
					<Footer />
				</>
				<div className="footerBottomAlignment"></div>
			</div>
		</>
	);
}
